import React, { useEffect, useState } from 'react';
import SideBar from '../../components/side-bar';
import { Container } from './styles';
import ArticleLayout from '../../components/article-layout';
import { SubjectsContextProvider } from '../../contexts/SubjectsContext';

function Aulas() {
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  useEffect(() => {
    window.addEventListener('resize', () => setWindowWidth(window.innerWidth));
    return () => {
      window.removeEventListener('resize', () => setWindowWidth(window.innerWidth));
    };
  }, []);

  const [sidebar, setSidebar] = useState(windowWidth >= 835);

  return (
    <SubjectsContextProvider>
      <Container>
        <SideBar
          sidebar={sidebar}
          setSidebar={setSidebar}
        />
        <ArticleLayout sidebar={sidebar} />
      </Container>
    </SubjectsContextProvider>
  );
  }

export default Aulas;
